import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AddSubprofileComponent } from './add-subprofile/add-subprofile.component';
import { LoaderService } from '../common/loader.service';
import { MasterService } from '../masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../user/user.services';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MenuPrivilegesComponent } from '../menu-privileges/menu-privileges.component';

@Component({
  selector: 'app-subprofile',
  templateUrl: './subprofile.component.html',
  styleUrls: ['./subprofile.component.scss']
})

export class SubprofileComponent implements OnInit {
  columnDefs:any[];
  rowData: any[];
  profileList=[];
  enableMenu=false;
  newSubProfile: AddSubprofileComponent;
  menuPrivilage: MenuPrivilegesComponent;
  subprofilesearchform:FormGroup;
  searchCriteria={};
  privilageList=[];
  menuList=[];
  addEditSubProfile=false;
  @ViewChild(AddSubprofileComponent, { static: true }) set Content(newSubProfileRef) {
    this.newSubProfile = newSubProfileRef;
  }
  @ViewChild(MenuPrivilegesComponent, { static: true }) set Content1(newMenuRef) {
    this.menuPrivilage = newMenuRef;
   } 
  constructor(private formBuilder: FormBuilder,private router:Router,private userService:UserService,private loaderService:LoaderService,private masterService:MasterService,private toasterService:ToastrService) { 

    this.columnDefs = [
      {headerName: 'Id', field: 'subProfileId'},
      {headerName: 'Description', field: 'description'},
      {headerName: 'Profile', field: 'profile'}
     
    ]; 
    this.getFromGroup();
    this.loadProfile();
    this.loadSubProfile();
    
  }

  ngOnInit() {
    
  }
  addSubProfile(){
    this.router.navigate(['addSubProfile']);
    this.newSubProfile.addSubProfileTitle = true;
    this.newSubProfile.editSubProfileTitle = false;
    
  }
  onRowClicked(event){
    this.newSubProfile.addSubProfileTitle = false;
    this.newSubProfile.editSubProfileTitle = true;
    this.addEditSubProfile=true;
    this.loadPrivilages();
    this.loadMenus();
    setTimeout(() => {
      this.loadSubProfileById(event.data.secSubProId);
    }, 250);
   
  }
  loadProfile() {
    this.userService.getProfile().subscribe(response => {
      this.profileList = response['result'];
    })
  }
  hideRightDiv() {
    this.addEditSubProfile = false;
  }
  loadSubProfileById(secSubProId){
    this.loaderService.display(true);
    let masterIp={
      secSubProId:secSubProId
    }  
  this.searchCriteria={
      masterShName:'SUB_PROFILE',
      master:masterIp
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
       this.loaderService.display(false);
       let result=response['result'];
       this.newSubProfile.patchSubProfileValue(result[0]);
       this.menuPrivilage.subProfileId=secSubProId;
       this.menuPrivilage.profileId=result[0]['secProId'];
       this.menuPrivilage.loadSelectedMenuAndPrivilage(secSubProId);
    },
    error => {
      this.loaderService.display(false);
    })
  }
  loadSubProfile(){
  this.loaderService.display(true);
  let masterIp={
    secProId:this.f.secProId.value,
    secProDescEn:this.f.secProDescEn.value,
    staRecCode:this.f.staRecCode.value ? 'A' : 'I'
  }

this.searchCriteria={
    masterShName:'SUB_PROFILE',
    master:masterIp
}
this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
     this.loaderService.display(false);
     let result=response['result'];
     for(let res of result){
      // console.log("value :"+)
        let pro=this.profileList.filter(profile => +profile.secProId === +res.secProId);
        res["profileDesc"]=pro ? pro[0].secProDescEn : null;
     }
    this.rowData = result;
  },
  error => {
    this.loaderService.display(false);
  })
}
get f() { return this.subprofilesearchform.controls; }

  private getFromGroup() {
    this.subprofilesearchform = this.formBuilder.group({
      'secProId': new FormControl(),
      'secProDescEn': new FormControl(),
      'staRecCode':[true]
    })
  }
  reset(){
    this.subprofilesearchform.reset();
  }
  loadPrivilages(){
    this.userService.getPrivilages().subscribe(response => {
      this.menuPrivilage.privilageList = response['result'];
    })
  }
  loadMenus(){
    this.userService.getMenus().subscribe(response => {
      this.menuPrivilage.menuList = response['result'];
    })
  }
}
